import { useCookieConsent } from '../consent/CookieConsentProvider.js';

/**
 * Whether to show the remember-me checkbox on auth screens.
 *
 * Sourced from CMP hydrate baseline (`showRememberMeField`):
 * - Functional already ON at hydrate → hide (persistence automatic)
 * - Functional OFF / no decision → show for this provider mount
 *
 * Checking the box may grant Functional later; that must NOT hide the field.
 */
export function useRememberMeFieldVisibility(): boolean {
  return useCookieConsent().showRememberMeField;
}

/** Persist flag: checkbox when shown; always true when Functional was already on. */
export function resolvePersistRefreshSession(opts: {
  showRememberMe: boolean;
  rememberMe: boolean;
}): boolean {
  return opts.showRememberMe ? opts.rememberMe : true;
}
